import { createContext, useContext } from 'react';

interface ApartmentDetailContextValue {
  propertyId: string;
  propertyGroupId: string | null;
  currency: string;
  readOnly: boolean;
}

export const ApartmentDetailContext = createContext<ApartmentDetailContextValue | null>(null);

export function useApartmentDetail(): ApartmentDetailContextValue {
  const ctx = useContext(ApartmentDetailContext);
  if (!ctx) throw new Error('useApartmentDetail must be inside ApartmentDetailLayout');
  return ctx;
}
